import axios from 'api/axios'
import { ClientProfile } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * API call to extend a client's trial by setting a new end date.
 * @param id - client id
 * @param trialEndsAt - Unix timestamp (ms) or ISO date string for new trial end
 * @returns Updated ClientProfile
 */
export const extendTrial = async (id: string, trialEndsAt: number | string) => {
	try {
		const { data } = await axios.patch<ClientProfile>(
			`client/trial/extend/${id}`,
			{ trialEndsAt }
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default extendTrial
